import { Schema as S } from "effect";

/**
 * Patient Search Request Schema
 *
 * Privacy-safe patient search using demographic data.
 * Only requires lastname + dob, with optional firstname for disambiguation.
 */
export const PatientSearchRequestSchema = S.Struct({
  /** Patient's last name (required) */
  lastname: S.String,
  /** Date of birth in YYYY-MM-DD format (required) */
  dob: S.String,
  /** Patient's first name (optional, used for disambiguation) */
  firstname: S.optional(S.String),
});

export type PatientSearchRequest = S.Schema.Type<
  typeof PatientSearchRequestSchema
>;
